import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import Header from '../../components/ui/Header';
import ProgressStepNavigation from '../../components/ui/ProgressStepNavigation';
import SuccessHeader from './components/SuccessHeader';
import ProcessingTimeline from './components/ProcessingTimeline';
import NextStepsSection from './components/NextStepsSection';
import SupportContactPanel from './components/SupportContactPanel';
import ActionButtons from './components/ActionButtons';

const SubmissionSuccessConfirmation = () => {
  const [referenceNumber] = useState('IDV-2024-' + Math.random().toString(36).substr(2, 9).toUpperCase());
  const [copySuccess, setCopySuccess] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Simulate loading time for smooth transition
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  const handleCopyReference = async () => {
    try {
      await navigator.clipboard.writeText(referenceNumber);
      setCopySuccess(true);
      setTimeout(() => setCopySuccess(false), 2000);
    } catch (err) {
      console.error('Failed to copy reference number:', err);
      // Fallback for older browsers
      const textArea = document.createElement('textarea');
      textArea.value = referenceNumber;
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand('copy');
      document.body.removeChild(textArea);
      setCopySuccess(true);
      setTimeout(() => setCopySuccess(false), 2000);
    }
  };

  const handlePrintReceipt = () => {
    // Analytics or logging can be added here
    console.log('Receipt printed for reference:', referenceNumber);
  };

  if (isLoading) {
    return (
      <div className="min-h-screen bg-background">
        <Header />
        <div className="pt-16">
          <ProgressStepNavigation />
          <div className="flex items-center justify-center min-h-[60vh]">
            <div className="text-center">
              <div className="w-16 h-16 border-4 border-primary border-t-transparent rounded-full animate-spin mx-auto mb-4" />
              <p className="text-text-secondary font-inter">Finalisation de votre demande...</p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background">
      <Helmet>
        <title>Vérification Soumise avec Succès</title>
        <meta name="description" content="Votre demande de vérification d'identité a été soumise avec succès. Suivez le statut de votre demande et consultez les prochaines étapes." />
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>

      <Header />
      
      <div className="pt-16">
        <ProgressStepNavigation />
        
        <main className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          {/* Success Header */}
          <SuccessHeader
            referenceNumber={referenceNumber}
            onCopyReference={handleCopyReference}
          />

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
            {/* Main Content */}
            <div className="lg:col-span-2 space-y-8">
              <NextStepsSection />
            </div>

            {/* Sidebar */}
            <div className="lg:col-span-1">
              <SupportContactPanel />
            </div>
          </div>

          {/* Action Buttons */}
          {/*<div className="mt-12 max-w-2xl mx-auto">
            <ActionButtons
              referenceNumber={referenceNumber}
              onPrintReceipt={handlePrintReceipt}
            />
          </div>*/}

          {/* Footer Information */}
          <div className="mt-16 pt-8 border-t border-border text-center">
            <div className="max-w-2xl mx-auto">
              <p className="text-sm text-text-secondary mb-4 font-inter">
                Cette page confirme la réception de votre demande de vérification d'identité. <br/>
                Vous pouvez fermer cette page en toute sécurité.
              </p>
              <div className="flex items-center justify-center space-x-6 text-xs text-text-muted">
                <span>© {new Date().getFullYear()} ID Verify</span>
                <span>•</span>
                <span className="hover:text-text-secondary transition-smooth focus:outline-none focus:underline">
                  Politique de confidentialité
                </span>
                <span>•</span>
                <span className="hover:text-text-secondary transition-smooth focus:outline-none focus:underline">
                  Conditions d'utilisation
                </span>
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};

export default SubmissionSuccessConfirmation;